export default __webpack_public_path__ + "static/figma-copy-paste-b1f1594b49bd3512704e430eff4d6292.png";